const isNotNullLastname = (data) => {
  const key = 'isNotNullLastname'
  const { value } = data
  const isEmpty = value === '' || value === null ? true : false
  const error = isEmpty ? key : false
  return error ? { error, data } : false
}

export default isNotNullLastname
